import { User, MapPin, Calendar, Briefcase, Hash } from 'lucide-react';


const PersonalizationPanel = ({ onInsertToken }) => {
  const tokens = [
    { 
      value: '{{commenter_name}}', 
      label: 'Name', 
      icon: User,
      description: 'Insert commenter\'s name'
    },
    { 
      value: '{{commenter_location}}', 
      label: 'Location', 
      icon: MapPin,
      description: 'Insert commenter\'s location'
    },
    { 
      value: '{{post_date}}', 
      label: 'Post Date', 
      icon: Calendar,
      description: 'Insert post date'
    },
    { 
      value: '{{brand_name}}', 
      label: 'Brand', 
      icon: Briefcase,
      description: 'Insert your brand name'
    },
    { 
      value: '{{topic}}', 
      label: 'Topic', 
      icon: Hash,
      description: 'Insert detected topic'
    }
  ];

  return (
    <div>
      <label className="text-xs font-medium text-gray-700 mb-2 block">Personalization Tokens</label>
      
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {tokens?.map((token) => {
          const IconComponent = token?.icon;
          return (
            <button
              key={token?.value}
              onClick={() => onInsertToken(token?.value)}
              className="flex items-center gap-2 p-2 bg-white border border-gray-300 rounded hover:bg-blue-50 hover:border-blue-400 transition-colors text-left"
              title={token?.description}
            >
              <IconComponent className="w-4 h-4 text-gray-600 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-xs font-medium text-gray-900 truncate">{token?.label}</p>
                <p className="text-xs text-gray-500 truncate">{token?.value}</p>
              </div>
            </button>
          );
        })}
      </div>
      
      <p className="text-xs text-gray-500 mt-2">
        Click a token to insert it into your response. It will be replaced with actual data when posted.
      </p>
    </div>
  );
};

export default PersonalizationPanel;